"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("EditPencil", React.createElement("path", { stroke: "currentColor", strokeWidth: 0.25, strokeLinecap: "round", strokeLinejoin: "round", d: "M3,18.6l-0.6,3.5l3.7-0.9L19.6,7.4l-2.8-2.8L3,18.6z M17.6,3.9l2.8,2.8l3-3l-2.8-2.8L17.6,3.9z" }));
//# sourceMappingURL=EditPencil.js.map